import { api } from "@/api/axios.ts";
import {
  ApiEmploymentContract,
  ApiEmploymentContractSavePayload,
} from "@/types/employment-contracts.types.ts";

export const apiEmploymentContracts = {
  getAll: () => {
    return api.get<ApiEmploymentContract[]>(`/api/v1/employment-contracts`);
  },
  create: (payload: ApiEmploymentContractSavePayload) => {
    return api.post<ApiEmploymentContract>(`/api/v1/employment-contracts`, payload);
  },
  update: (id: number, payload: ApiEmploymentContractSavePayload) => {
    return api.put<ApiEmploymentContract>(`/api/v1/employment-contracts/${id}`, payload);
  },
  delete: (id: number) => {
    return api.delete(`/api/v1/employment-contracts/${id}`);
  },
};
